import actions from '../actions'

const logout = () => dispatch => {
  localStorage.removeItem('tcfAuthHeader')
  // delete axios.defaults.headers.common.Authorization
  dispatch(actions.logout())
}

export default logout
